/**
 * Search Form Block - Mobile Tabs Handler & Select Placeholder
 * Gere l'affichage des onglets sur mobile et le style des placeholders
 */

document.addEventListener('DOMContentLoaded', function() {
    // ========================================
    // Mobile Tabs Functionality
    // ========================================
    const tabLinks = document.querySelectorAll('.mobile-tabs .tab-link');
    const formGroups = document.querySelectorAll('.defaults .-form-group:not(.submit-ctnr)');

    // Fonction pour activer un onglet
    function activateTab(targetClass) {
        // Retirer la classe active de tous les boutons
        tabLinks.forEach(function(link) {
            link.classList.remove('-active');
        });

        // Masquer tous les form-groups sauf submit-ctnr
        formGroups.forEach(function(group) {
            group.classList.remove('-active');
        });

        // Activer le bouton clique
        const activeButton = document.querySelector('.tab-link[data-tab="' + targetClass + '"]');
        if (activeButton) {
            activeButton.classList.add('-active');
        }

        // Afficher le form-group correspondant
        const activeGroup = document.querySelector('.defaults .-form-group' + targetClass);
        if (activeGroup) {
            activeGroup.classList.add('-active');
        }
    }

    // Ajouter les ecouteurs d'evenements sur les boutons d'onglets
    tabLinks.forEach(function(link) {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            const targetTab = this.getAttribute('data-tab');
            activateTab(targetTab);
        });
    });

    // Activer le premier onglet par defaut au chargement
    if (tabLinks.length > 0) {
        const firstTab = tabLinks[0].getAttribute('data-tab');
        activateTab(firstTab);
    }

    // ========================================
    // Select Placeholder Styling
    // ========================================
    function handleSelectPlaceholder(select) {
        if (select.value === '' || select.value === null) {
            select.classList.add('is-placeholder');
        } else {
            select.classList.remove('is-placeholder');
        }
    }

    // Appliquer a tous les selects avec la classe select-placeholder
    const selects = document.querySelectorAll('select.select-placeholder');
    selects.forEach(function(select) {
        // Etat initial
        handleSelectPlaceholder(select);

        // A chaque changement
        select.addEventListener('change', function() {
            handleSelectPlaceholder(this);
        });
    });

    // ========================================
    // Departure Month to Date Range Conversion
    // ========================================
    const departureMonthSelect = document.getElementById('departure_month');

    if (departureMonthSelect) {
        departureMonthSelect.addEventListener('change', function() {
            const monthValue = this.value; // Format: "YYYY-MM-01"

            if (monthValue) {
                // Extract year and month from the value
                const dateParts = monthValue.split('-');
                const year = parseInt(dateParts[0], 10);
                const month = parseInt(dateParts[1], 10);

                // Calculate first day of month (already in correct format)
                const startDate = monthValue; // "YYYY-MM-01"

                // Calculate last day of month
                // Create date object for first day of next month, then subtract one day
                const lastDay = new Date(year, month, 0).getDate();
                const endDate = year + '-' + String(month).padStart(2, '0') + '-' + String(lastDay).padStart(2, '0');

                // Update hidden inputs
                const startDateInput = document.querySelector('.startDateHidden');
                const endDateInput = document.querySelector('.endDateHidden');

                if (startDateInput) {
                    startDateInput.value = startDate;
                }

                if (endDateInput) {
                    endDateInput.value = endDate;
                }
            }
        });
    }
});
